import { sortOptions } from "@/helpers/inventarisation/sortOptions";
import type { LandType } from "../HDN/LandType";
import type { InventarisationSelectOption } from "./InventarisationSelectOption";
import { addEmptyOption } from "@/composables/useXsdToFormKit";

export const countryOptions: InventarisationSelectOption<LandType>[] = [
	{
		label: "Verenigde Arabische Emiraten",
		value: "AE Verenigde Arabische Emiraten",
	},
	{ label: "Afghanistan", value: "AF Afghanistan" },
	{ label: "Antigua en Barbuda", value: "AG Antigua en Barbuda" },
	{ label: "Anguilla", value: "AI Anguilla" },
	{ label: "Albanië", value: "AL Albanië" },
	{ label: "Armenië", value: "AM Armenië" },
	{ label: "Angola", value: "AO Angola" },
	{ label: "Antarctica", value: "AQ Antarctica" },
	{ label: "Argentinië", value: "AR Argentinië" },
	{ label: "Amerikaans-Samoa", value: "AS Amerikaans-Samoa" },
	{ label: "Oostenrijk", value: "AT Oostenrijk" },
	{ label: "Australië", value: "AU Australië" },
	{ label: "Aruba", value: "AW Aruba" },
	{ label: "Åland", value: "AX Åland" },
	{ label: "Azerbeidzjan", value: "AZ Azerbeidzjan" },
	{ label: "Bosnië Herzegovina", value: "BA Bosnië Herzegovina" },
	{ label: "Barbados", value: "BB Barbados" },
	{ label: "Bangladesh", value: "BD Bangladesh" },
	{ label: "België", value: "BE België" },
	{ label: "Burkina Faso", value: "BF Burkina Faso" },
	{ label: "Bulgarije", value: "BG Bulgarije" },
	{ label: "Bahrein", value: "BH Bahrein" },
	{ label: "Burundi", value: "BI Burundi" },
	{ label: "Benin", value: "BJ Benin" },
	{ label: "Saint-Barthélemy", value: "BL Saint-Barthélemy" },
	{ label: "Bermuda", value: "BM Bermuda" },
	{ label: "Brunei", value: "BN Brunei" },
	{ label: "Bolivia", value: "BO Bolivia" },
	{
		label: "Bonaire, Sint Eustatius en Saba",
		value: "BQ Bonaire, Sint Eustatius en Saba",
	},
	{ label: "Brazilië", value: "BR Brazilië" },
	{ label: "Bahama's", value: "BS Bahama's" },
	{ label: "Bhutan", value: "BT Bhutan" },
	{ label: "Bouveteiland", value: "BV Bouveteiland" },
	{ label: "Botswana", value: "BW Botswana" },
	{ label: "Wit-Rusland", value: "BY Wit-Rusland" },
	{ label: "Belize", value: "BZ Belize" },
	{ label: "Canada", value: "CA Canada" },
	{ label: "Cocoseilanden", value: "CC Cocoseilanden" },
	{ label: "Congo-Kinshasa", value: "CD Congo-Kinshasa" },
	{
		label: "Centraal-Afrikaanse Republiek",
		value: "CF Centraal-Afrikaanse Republiek",
	},
	{ label: "Republiek Congo", value: "CG Republiek Congo" },
	{ label: "Zwitserland", value: "CH Zwitserland" },
	{ label: "Ivoorkust", value: "CI Ivoorkust" },
	{ label: "Cookeilanden", value: "CK Cookeilanden" },
	{ label: "Chili", value: "CL Chili" },
	{ label: "Kameroen", value: "CM Kameroen" },
	{ label: "China", value: "CN China" },
	{ label: "Colombia", value: "CO Colombia" },
	{ label: "Costa Rica", value: "CR Costa Rica" },
	{ label: "Cuba", value: "CU Cuba" },
	{ label: "Kaapverdië", value: "CV Kaapverdië" },
	{ label: "Curaçao", value: "CW Curaçao" },
	{ label: "Christmaseiland", value: "CX Christmaseiland" },
	{ label: "Cyprus", value: "CY Cyprus" },
	{ label: "Tsjechië", value: "CZ Tsjechië" },
	{ label: "Duitsland", value: "DE Duitsland" },
	{ label: "Djibouti", value: "DJ Djibouti" },
	{ label: "Denemarken", value: "DK Denemarken" },
	{ label: "Dominica", value: "DM Dominica" },
	{ label: "Dominicaanse Republiek", value: "DO Dominicaanse Republiek" },
	{ label: "Algerije", value: "DZ Algerije" },
	{ label: "Ecuador", value: "EC Ecuador" },
	{ label: "Estland", value: "EE Estland" },
	{ label: "Egypte", value: "EG Egypte" },
	{ label: "Westelijke Sahara", value: "EH Westelijke Sahara" },
	{ label: "Eritrea", value: "ER Eritrea" },
	{ label: "Spanje", value: "ES Spanje" },
	{ label: "Ethiopië", value: "ET Ethiopië" },
	{ label: "Finland", value: "FI Finland" },
	{ label: "Fiji", value: "FJ Fiji" },
	{ label: "Falklandeilanden", value: "FK Falklandeilanden" },
	{ label: "Micronesia", value: "FM Micronesia" },
	{ label: "Faeröer", value: "FO Faeröer" },
	{ label: "Frankrijk", value: "FR Frankrijk" },
	{ label: "Gabon", value: "GA Gabon" },
	{ label: "Verenigd Koninkrijk", value: "GB Verenigd Koninkrijk" },
	{ label: "Grenada", value: "GD Grenada" },
	{ label: "Georgië", value: "GE Georgië" },
	{ label: "Frans-Guyana", value: "GF Frans-Guyana" },
	{ label: "Guernsey", value: "GG Guernsey" },
	{ label: "Ghana", value: "GH Ghana" },
	{ label: "Gibraltar", value: "GI Gibraltar" },
	{ label: "Groenland", value: "GL Groenland" },
	{ label: "Gambia", value: "GM Gambia" },
	{ label: "Guinee", value: "GN Guinee" },
	{ label: "Guadeloupe", value: "GP Guadeloupe" },
	{ label: "Equatoriaal-Guinea", value: "GQ Equatoriaal-Guinea" },
	{ label: "Griekenland", value: "GR Griekenland" },
	{
		label: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
		value: "GS Zuid-Georgia en de Zuidelijke Sandwicheilanden",
	},
	{ label: "Guatemala", value: "GT Guatemala" },
	{ label: "Guam", value: "GU Guam" },
	{ label: "Guinee-Bissau", value: "GW Guinee-Bissau" },
	{ label: "Guyana", value: "GY Guyana" },
	{ label: "Hongkong", value: "HK Hongkong" },
	{ label: "Heard en McDonaldeilanden", value: "HM Heard en McDonaldeilanden" },
	{ label: "Honduras", value: "HN Honduras" },
	{ label: "Kroatië", value: "HR Kroatië" },
	{ label: "Haïti", value: "HT Haïti" },
	{ label: "Hongarije", value: "HU Hongarije" },
	{ label: "Indonesië", value: "ID Indonesië" },
	{ label: "Ierland", value: "IE Ierland" },
	{ label: "Israël", value: "IL Israël" },
	{ label: "Man", value: "IM Man" },
	{ label: "India", value: "IN India" },
	{
		label: "Brits Indische Oceaanterritorium",
		value: "IO Brits Indische Oceaanterritorium",
	},
	{ label: "Irak", value: "IQ Irak" },
	{ label: "Iran", value: "IR Iran" },
	{ label: "IJsland", value: "IS IJsland" },
	{ label: "Italië", value: "IT Italië" },
	{ label: "Jersey", value: "JE Jersey" },
	{ label: "Jamaica", value: "JM Jamaica" },
	{ label: "Jordanië", value: "JO Jordanië" },
	{ label: "Japan", value: "JP Japan" },
	{ label: "Kenia", value: "KE Kenia" },
	{ label: "Kirgizië", value: "KG Kirgizië" },
	{ label: "Cambodja", value: "KH Cambodja" },
	{ label: "Kiribati", value: "KI Kiribati" },
	{ label: "Comoren", value: "KM Comoren" },
	{ label: "Saint Kitts en Nevis", value: "KN Saint Kitts en Nevis" },
	{ label: "Noord-Korea", value: "KP Noord-Korea" },
	{ label: "Zuid-Korea", value: "KR Zuid-Korea" },
	{ label: "Koeweit", value: "KW Koeweit" },
	{ label: "Kaaimaneilanden", value: "KY Kaaimaneilanden" },
	{ label: "Kazachstan", value: "KZ Kazachstan" },
	{ label: "Laos", value: "LA Laos" },
	{ label: "Libanon", value: "LB Libanon" },
	{ label: "Saint Lucia", value: "LC Saint Lucia" },
	{ label: "Liechtenstein", value: "LI Liechtenstein" },
	{ label: "Sri Lanka", value: "LK Sri Lanka" },
	{ label: "Liberia", value: "LR Liberia" },
	{ label: "Lesotho", value: "LS Lesotho" },
	{ label: "Litouwen", value: "LT Litouwen" },
	{ label: "Luxemburg", value: "LU Luxemburg" },
	{ label: "Letland", value: "LV Letland" },
	{ label: "Libië", value: "LY Libië" },
	{ label: "Marokko", value: "MA Marokko" },
	{ label: "Monaco", value: "MC Monaco" },
	{ label: "Moldavië", value: "MD Moldavië" },
	{ label: "Montenegro", value: "ME Montenegro" },
	{ label: "Sint-Maarten (FR)", value: "MF Sint-Maarten (FR)" },
	{ label: "Madagaskar", value: "MG Madagaskar" },
	{ label: "Marshalleilanden", value: "MH Marshalleilanden" },
	{ label: "Noord Macedonië", value: "MK Noord Macedonië" },
	{ label: "Mali", value: "ML Mali" },
	{ label: "Myanmar", value: "MM Myanmar" },
	{ label: "Mongolië", value: "MN Mongolië" },
	{ label: "Macau", value: "MO Macau" },
	{ label: "Noordelijke Marianen", value: "MP Noordelijke Marianen" },
	{ label: "Martinique", value: "MQ Martinique" },
	{ label: "Mauritanië", value: "MR Mauritanië" },
	{ label: "Montserrat", value: "MS Montserrat" },
	{ label: "Malta", value: "MT Malta" },
	{ label: "Mauritius", value: "MU Mauritius" },
	{ label: "Maldiven", value: "MV Maldiven" },
	{ label: "Malawi", value: "MW Malawi" },
	{ label: "Mexico", value: "MX Mexico" },
	{ label: "Maleisië", value: "MY Maleisië" },
	{ label: "Mozambique", value: "MZ Mozambique" },
	{ label: "Namibië", value: "NA Namibië" },
	{ label: "Nieuw-Caledonië", value: "NC Nieuw-Caledonië" },
	{ label: "Niger", value: "NE Niger" },
	{ label: "Norfolk", value: "NF Norfolk" },
	{ label: "Nigeria", value: "NG Nigeria" },
	{ label: "Nicaragua", value: "NI Nicaragua" },
	{ label: "Nederland", value: "NL Nederland" },
	{ label: "Noorwegen", value: "NO Noorwegen" },
	{ label: "Nepal", value: "NP Nepal" },
	{ label: "Nauru", value: "NR Nauru" },
	{ label: "Niue", value: "NU Niue" },
	{ label: "Nieuw-Zeeland", value: "NZ Nieuw-Zeeland" },
	{ label: "Oman", value: "OM Oman" },
	{ label: "Panama", value: "PA Panama" },
	{ label: "Peru", value: "PE Peru" },
	{ label: "Frans-Polynesië", value: "PF Frans-Polynesië" },
	{ label: "Papoea-Nieuw-Guinea", value: "PG Papoea-Nieuw-Guinea" },
	{ label: "Filipijnen", value: "PH Filipijnen" },
	{ label: "Pakistan", value: "PK Pakistan" },
	{ label: "Polen", value: "PL Polen" },
	{ label: "Saint-Pierre en Miquelon", value: "PM Saint-Pierre en Miquelon" },
	{ label: "Pitcairneilanden", value: "PN Pitcairneilanden" },
	{ label: "Puerto Rico", value: "PR Puerto Rico" },
	{ label: "Palestina", value: "PS Palestina" },
	{ label: "Portugal", value: "PT Portugal" },
	{ label: "Palau", value: "PW Palau" },
	{ label: "Paraguay", value: "PY Paraguay" },
	{ label: "Qatar", value: "QA Qatar" },
	{ label: "Réunion", value: "RE Réunion" },
	{ label: "Roemenië", value: "RO Roemenië" },
	{ label: "Servië", value: "RS Servië" },
	{ label: "Rusland", value: "RU Rusland" },
	{ label: "Rwanda", value: "RW Rwanda" },
	{ label: "Saoedi-Arabië", value: "SA Saoedi-Arabië" },
	{ label: "Salomonseilanden", value: "SB Salomonseilanden" },
	{ label: "Seychellen", value: "SC Seychellen" },
	{ label: "Soedan", value: "SD Soedan" },
	{ label: "Zweden", value: "SE Zweden" },
	{ label: "Singapore", value: "SG Singapore" },
	{
		label: "Sint-Helena, Ascension en Tristan da Cunha",
		value: "SH Sint-Helena, Ascension en Tristan da Cunha",
	},
	{ label: "Slovenië", value: "SI Slovenië" },
	{ label: "Spitsbergen en Jan Mayen", value: "SJ Spitsbergen en Jan Mayen" },
	{ label: "Slowakije", value: "SK Slowakije" },
	{ label: "Sierra Leone", value: "SL Sierra Leone" },
	{ label: "San Marino", value: "SM San Marino" },
	{ label: "Senegal", value: "SN Senegal" },
	{ label: "Somalië", value: "SO Somalië" },
	{ label: "Suriname", value: "SR Suriname" },
	{ label: "Zuid-Soedan", value: "SS Zuid-Soedan" },
	{ label: "Sao Tomé en Principe", value: "ST Sao Tomé en Principe" },
	{ label: "El Salvador", value: "SV El Salvador" },
	{ label: "Sint-Maarten (NL)", value: "SX Sint-Maarten (NL)" },
	{ label: "Syrië", value: "SY Syrië" },
	{ label: "Swaziland", value: "SZ Swaziland" },
	{ label: "Turks- en Caicoseilanden", value: "TC Turks- en Caicoseilanden" },
	{ label: "Tsjaad", value: "TD Tsjaad" },
	{
		label: "Franse Zuidelijke en Antarctische Gebieden",
		value: "TF Franse Zuidelijke en Antarctische Gebieden",
	},
	{ label: "Togo", value: "TG Togo" },
	{ label: "Thailand", value: "TH Thailand" },
	{ label: "Tadzjikistan", value: "TJ Tadzjikistan" },
	{ label: "Tokelau", value: "TK Tokelau" },
	{ label: "Oost-Timor", value: "TL Oost-Timor" },
	{ label: "Turkmenistan", value: "TM Turkmenistan" },
	{ label: "Tunesië", value: "TN Tunesië" },
	{ label: "Tonga", value: "TO Tonga" },
	{ label: "Turkije", value: "TR Turkije" },
	{ label: "Trinidad en Tobago", value: "TT Trinidad en Tobago" },
	{ label: "Tuvalu", value: "TV Tuvalu" },
	{ label: "Taiwan", value: "TW Taiwan" },
	{ label: "Tanzania", value: "TZ Tanzania" },
	{ label: "Oekraïne", value: "UA Oekraïne" },
	{ label: "Oeganda", value: "UG Oeganda" },
	{
		label: "Kleine Pacifische eilanden van de Verenigde Staten",
		value: "UM Kleine Pacifische eilanden van de Verenigde Staten",
	},
	{ label: "Verenigde Staten", value: "US Verenigde Staten" },
	{ label: "Uruguay", value: "UY Uruguay" },
	{ label: "Oezbekistan", value: "UZ Oezbekistan" },
	{ label: "Vaticaanstad", value: "VA Vaticaanstad" },
	{
		label: "Saint Vincent en de Grenadines",
		value: "VC Saint Vincent en de Grenadines",
	},
	{ label: "Venezuela", value: "VE Venezuela" },
	{ label: "Britse Maagdeneilanden", value: "VG Britse Maagdeneilanden" },
	{
		label: "Amerikaanse Maagdeneilanden",
		value: "VI Amerikaanse Maagdeneilanden",
	},
	{ label: "Vietnam", value: "VN Vietnam" },
	{ label: "Vanuatu", value: "VU Vanuatu" },
	{ label: "Wallis en Futuna", value: "WF Wallis en Futuna" },
	{ label: "Samoa", value: "WS Samoa" },
	// { label: "Kosovo", value: "XK Kosovo" },
	{ label: "Jemen", value: "YE Jemen" },
	{ label: "Mayotte", value: "YT Mayotte" },
	{ label: "Zuid-Afrika", value: "ZA Zuid-Afrika" },
	{ label: "Zambia", value: "ZM Zambia" },
	{ label: "Zimbabwe", value: "ZW Zimbabwe" },
];

export const sortedCountries = addEmptyOption(sortOptions(countryOptions));
